// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"deposit_wrapper__3lTOA","btnCopy":"deposit_btnCopy__17BiO","howToTransfer":"deposit_howToTransfer__3di6B"};